import { AppError, toUserMessage } from "./errors";

const PROFILE_SAVE_ERROR_MESSAGE = "プロファイルを保存できませんでした。入力内容を確認してください。";

function parseResponseMessage(error: AppError): string | null {
  const responseText = error.meta.responseText;
  if (!responseText) return null;

  try {
    const parsed = JSON.parse(responseText) as unknown;
    if (!parsed || typeof parsed !== "object") return null;
    const message = (parsed as { message?: unknown }).message;
    return typeof message === "string" && message.trim() ? message.trim() : null;
  } catch {
    return null;
  }
}

function isProfileValidationError(error: unknown): error is AppError {
  return (
    error instanceof AppError &&
    (error.code === "BAD_REQUEST" || error.meta.status === 400 || error.meta.status === 422)
  );
}

export function toProfileSaveErrorMessage(error: unknown): string {
  if (isProfileValidationError(error)) {
    return parseResponseMessage(error) ?? PROFILE_SAVE_ERROR_MESSAGE;
  }

  return toUserMessage(error);
}
